import { environment } from 'src/environments/environment';

// Las altas B2B están en la raíz de la API, fuera de /importacion/*.
const RUTAS_REGISTRO_IMPORTACION = [
	'ProcesoImportacionJsonIngresoBarcaza',
	'ProcesoImportacionJsonTrasladoBarcaza',
	'ProcesoImportacionJsonMoliendaBarcaza',
	'ProcesoImportacionJsonEmbarqueBarcaza'
] as const;

/** Base pública del host/APIM de Importación. */
export function getImportacionApiUrl(): string {
	const value = environment.apiUrlImportacion?.trim();
	if (!value || value.includes('${') || value.includes('#{')) return '';
	try {
		const url = new URL(value);
		if (
			!['https:', 'http:'].includes(url.protocol) ||
			url.search ||
			url.hash ||
			url.username ||
			url.password
		)
			return '';
		return url.href.replace(/\/$/, '');
	} catch {
		return '';
	}
}

export function getImportacionRegistroUrls(): string[] {
	const base = getImportacionApiUrl();
	return base ? RUTAS_REGISTRO_IMPORTACION.map(ruta => `${base}/${ruta}`) : [];
}

export function isImportacionRequest(url: string): boolean {
	const base = getImportacionApiUrl();
	if (!base) return false;
	try {
		const destino = new URL(url);
		if (destino.username || destino.password) return false;
		const recurso = `${destino.origin}${destino.pathname}`;
		return (
			recurso.startsWith(`${base}/importacion/`) ||
			getImportacionRegistroUrls().includes(recurso)
		);
	} catch {
		return false;
	}
}
